import { render, staticRenderFns } from "./publicityQuery.vue?vue&type=template&id=b45868c6&scoped=true"
import script from "./publicityQuery.vue?vue&type=script&lang=js"
export * from "./publicityQuery.vue?vue&type=script&lang=js"
import style0 from "./publicityQuery.vue?vue&type=style&index=0&id=b45868c6&prod&lang=less&scoped=true"
import style1 from "./publicityQuery.vue?vue&type=style&index=1&id=b45868c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45868c6",
  null
  
)

export default component.exports